import { FilterNavigatorV3Props } from './@types/FilterNavigatorV3Props';
import Container from './handles/Container';
import Title from './handles/Title';
import FiterContentCor from './handles/FilterContentCor';
import FilterButton from './handles/FilterButton';
import FilterPrice from './handles/FilterPrice';
import Drawer from './handles/Drawer';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectedToggleValue } from '../../../redux/canvasResolutionSlice';

type CanvasWidth = {
	canvasWidth: 1080 | 1024 | 640;
};

const filters = [
	{ title: 'Cor', items: ['Preto', 'Branco', 'Verde'] },
	{ title: 'Departamento', items: ['Masculino', 'Feminino'] },
];
type AllProps = FilterNavigatorV3Props & CanvasWidth & { componentId: string };

const FilterNavigatorV3 = (props: AllProps) => {
	const toggleValue = useSelector(selectedToggleValue);
	const [isOpen, setIsOpen] = useState(false);

	return toggleValue > 1024 ? (
		<Container {...{ props }}>
			<Title text="Filtros" />
			{filters.map((filter) => (
				<FiterContentCor filter={filter} />
			))}

			<FilterPrice />
		</Container>
	) : (
		<Container {...{ props }}>
			<FilterButton isOpen={isOpen} setIsOpen={setIsOpen} />
			<Drawer isOpen={isOpen} setIsOpen={setIsOpen} />
		</Container>
	);
};

export default FilterNavigatorV3;
